import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { ProductCard } from '../product/ProductCard';
import { products } from '../../data/products';
import type { CategoryId } from '../../types/product';
type Filter = 'all' | CategoryId;
const filters: {
  id: Filter;
  label: string;
}[] = [{
  id: 'all',
  label: 'All'
}, {
  id: 'home-batteries',
  label: 'Home batteries'
}, {
  id: 'plug-in',
  label: 'Plug-in'
}, {
  id: 'power-stations',
  label: 'Power stations'
}, {
  id: 'solar-panels',
  label: 'Solar panels'
}];
export function BestSellers() {
  const [active, setActive] = useState<Filter>('all');
  const visible = (active === 'all' ? products : products.filter(p => p.category === active)).slice().sort((a, b) => b.reviews - a.reviews).slice(0, 8);
  return <section aria-labelledby="products-heading" className="bg-surface py-12 lg:py-16" data-id="element-100" data-mp="1xjvh4sw2adlb">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-101" data-mp="1tjjuxbo1w57q">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-102" data-mp="2dz064wu1cqvl">
          <div data-id="element-103" data-mp="2ix1x03xpduhm">
            <h2 id="products-heading" className="text-2xl font-bold tracking-tight text-ink sm:text-[28px]" data-id="element-104" data-mp="2iws3459jf36n">
              Best sellers
            </h2>
            <p className="mt-1 text-sm text-muted" data-id="element-105" data-mp="2mxc2lfhl2ivy">What customers in NL &amp; BE are ordering this month</p>
          </div>
          <div role="tablist" aria-label="Filter products" className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1 sm:mx-0 sm:px-0 md:pb-0" data-id="element-106" data-mp="1v88xxylsb6is">
            {filters.map(f => {
            const isActive = f.id === active;
            return <button key={f.id} role="tab" aria-selected={isActive} onClick={() => setActive(f.id)} className={`h-9 shrink-0 whitespace-nowrap rounded-full border px-4 text-sm font-medium transition-colors duration-150 ${isActive ? 'border-ink bg-ink text-white' : 'border-line bg-white text-ink hover:border-ink/30'}`} data-id="element-107" data-mp="24746hhcawsp9">
                  {f.label}
                </button>;
          })}
          </div>
        </div>

        <ul className="mt-6 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4 lg:gap-5" data-id="element-108" data-mp="2sl0mj30pshhs">
          {visible.map(p => <li key={p.id} data-id="element-109" data-mp="2olidp5m63wvb">
              <ProductCard product={p} data-id="element-110" data-mp="20v4khbrujrz5" />
            </li>)}
        </ul>

        <div className="mt-8 flex justify-center" data-id="element-111" data-mp="20x8mfo66qgws">
          <Link to={active === 'all' ? '/shop' : `/shop/${active}`} className="inline-flex h-11 items-center gap-2 rounded-lg border border-ink/15 bg-white px-5 text-sm font-semibold text-ink transition-colors duration-150 hover:border-ink" data-id="element-112" data-mp="1vwt6qpyfkxbn">
            View all products
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-113" data-mp="3l9y6rbohkod6" />
          </Link>
        </div>
      </div>
    </section>;
}